import PropTypes from 'prop-types';
import React from 'react';
import SubHeading from '../SubHeading/index.js';
import Box from '../Box/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TimelineItem(_ref) {
  let {
    label,
    value
  } = _ref;
  return /*#__PURE__*/_jsxs("li", {
    className: "timeline-item",
    "data-cmp": "timelineItem",
    children: [/*#__PURE__*/_jsx("span", {
      className: "timeline-label",
      children: label
    }), /*#__PURE__*/_jsx("span", {
      className: "timeline-value",
      children: value
    })]
  });
}
function Timeline(_ref2) {
  let {
    data = [],
    header = '',
    ...rest
  } = _ref2;
  if (data.length === 0) return null;
  return /*#__PURE__*/_jsxs(Box, {
    backgroundColor: "neutral-primary-transparent-40",
    "data-cmp": "timeline",
    ...rest,
    children: [/*#__PURE__*/_jsx(SubHeading, {
      level: 3,
      className: "margin-bottom-4",
      children: header
    }), /*#__PURE__*/_jsx("ol", {
      className: "timeline",
      children: data.map((item, key) => /*#__PURE__*/_jsx(TimelineItem, {
        label: item.label,
        value: item.value
      }, key))
    })]
  });
}
export default Timeline;